const menuWidth = 310;
/**
 * スタイル定義
 */
export const styles = (theme) => {
  return {
    headerDiv: {
      height: 53,
    },
    stagingMode: {
      backgroundColor: '#fff7b2',
    },
    hyokaMode: {
      backgroundColor: '#ffa589',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      minHeight: 53,
    },
    menuButton: {
      padding: 6,
    },
    grow: {
      flexGrow: 1,
    },
    icon: {
      color: theme.palette.icon.secondary,
      marginRight: 5,
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
      },
    },
    menuIcon: {
      color: theme.palette.icon.primary,
      marginRight: 5,
    },
    icon2: {
      color: theme.palette.icon.secondary,
    },
    appTitle: {
      marginLeft: 16,
      cursor: 'pointer',
      fontWeight: 'bold',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 8,
        marginRight: '2ch',
        fontSize: '1.15rem',
        minWidth: 0,
        flexShrink: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    root: {
      display: 'flex',
      height: '100%',
    },
    drawerPaper: {
      display: 'block',
      width: menuWidth,
      height: 'auto',
      top: 50,
      bottom: 0,
      maxWidth: menuWidth,
      backgroundColor: theme.palette.secondary.main,
    },
    drawerPaperClose: {
      display: 'none',
    },
    drawerPaperMobile: {
      display: 'block',
      width: menuWidth,
      height: 'auto',
      bottom: 0,
      maxWidth: menuWidth,
      backgroundColor: theme.palette.secondary.main,
    },
    content: {
      flexGrow: 1,
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: menuWidth + theme.spacing(1),
    },
    divider: {
      height: 1,
    },
    nestedDivider: {
      marginLeft: theme.spacing(4),
    },
    menuItemLv2: {
      paddingTop: 8,
      paddingBottom: 8,
    },
    menuItemLv3: {
      paddingLeft: theme.spacing(6),
    },
    menuItemButton: {
      '&:focus': {
        backgroundColor: 'initial',
      },
      '&:hover': {
        backgroundColor: '#199EEA',
      },
    },
    menuRoot: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    menuFontWeight: {
      fontWeight: 'normal',
      color: theme.palette.secondary.contrastText,
    },
    menuText: {
      padding: 0,
    },
    menuList: {
      height: 'auto !important',
      minHeight: '100%',
    },
    menuClose: {
      paddingLeft: theme.spacing(1),
    },
    additionalMenuItem: {
      width: '100%',
    },
    additionalMenuItemButton: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 0,
      paddingTop: 0,
      paddingRight: 0,
      fontWeight: 'normal',
      fontSize: theme.typography.fontSize * 0.8,
      color: theme.palette.secondary.contrastText,
      textAlign: 'right',
    },
    accent: {
      backgroundColor: theme.palette.accent.main,
      color: theme.palette.accent.contrastText,
      paddingLeft: 8,
      paddingTop: 4,
      paddingBottom: 4,
    },
    noHeader: {
      marginTop: -64,
    },
    sectionDesktop: {
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
    },
    progress: {
      position: 'absolute',
      top: 50,
      left: 0,
      margin: 0,
      padding: 0,
      height: 4,
      width: '100%',
    },
    actionItem: {
      marginLeft: theme.spacing(2)
    },
  };
};
